import React from "react";

const ApiEndpointBlock = ({ title, method, path, url, description, auth, request, response, errors, notes }) => {
    return (
        <div className="mb-12">
            <h3 className="text-xl font-semibold text-brand-blue mt-6">{title}</h3>
            <p className="mb-2">
                <strong>{method}</strong>{" "}
                <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                    {path}
                </a>
            </p>
            <p>{description}</p>

            {auth && (
                <>
                    <h4 className="font-semibold mt-4">🔐 Autenticación</h4>
                    <pre className="bg-gray-100 p-2 rounded text-sm">{auth}</pre>
                </>
            )}

            {request && (
                <>
                    <h4 className="font-semibold mt-4">📥 Ejemplo de petición</h4>
                    <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">{request}</pre>
                </>
            )}

            {response && (
                <>
                    <h4 className="font-semibold mt-4">📤 Ejemplo de respuesta</h4>
                    <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">{response}</pre>
                </>
            )}

            {errors && (
                <>
                    <h4 className="font-semibold mt-4">⚠️ Posibles errores</h4>
                    <table className="w-full text-sm mt-2 border border-gray-300">
                        <thead className="bg-gray-100">
                        <tr>
                            <th className="border px-2 py-1">Código</th>
                            <th className="border px-2 py-1 text-left">Descripción</th>
                        </tr>
                        </thead>
                        <tbody>
                        {errors.map((err, idx) => (
                            <tr key={idx}>
                                <td className="border px-2 py-1">{err.code}</td>
                                <td className="border px-2 py-1">{err.desc}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </>
            )}

            {notes && (
                <>
                    <h4 className="font-semibold mt-4">🧠 Observaciones</h4>
                    <ul className="list-disc pl-6 text-sm">
                        {notes.map((n, idx) => (
                            <li key={idx}>{n}</li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default ApiEndpointBlock;
